import { render, staticRenderFns } from "./configuracaotiss.vue?vue&type=template&id=77fa11ca"
import script from "./configuracaotiss.vue?vue&type=script&lang=js"
export * from "./configuracaotiss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports